module.exports = __webpack_public_path__ + "img/mastercard.34a9df72.svg";